"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Types_1 = require("../../Types");
var reactstrap_1 = require("reactstrap");
exports.PackDetailsInformationEvent = function (resources, request, pack) {
    return new Types_1.VeriLiteInformationEvent(React.createElement(Details, { resources: resources, request: request, pack: pack }), resources.PackDetails, []);
};
var Details = /** @class */ (function (_super) {
    __extends(Details, _super);
    function Details(props) {
        return _super.call(this, props) || this;
    }
    Details.prototype.render = function () {
        var _a, _b, _c, _d;
        return (React.createElement(reactstrap_1.Table, { size: "sm", bordered: true },
            React.createElement("tbody", null,
                React.createElement("tr", null,
                    React.createElement("th", { scope: "row" }, this.props.resources.User),
                    React.createElement("td", null, (_b = (_a = this.props.request) === null || _a === void 0 ? void 0 : _a.userInfo) === null || _b === void 0 ? void 0 :
                        _b.DisplayName,
                        " (", (_d = (_c = this.props.request) === null || _c === void 0 ? void 0 : _c.userInfo) === null || _d === void 0 ? void 0 :
                        _d.Email,
                        ")")),
                React.createElement("tr", null,
                    React.createElement("th", { scope: "row" }, this.props.resources.Action),
                    React.createElement("td", null, this.props.request.additionalInfo.action)),
                React.createElement("tr", null,
                    React.createElement("th", { scope: "row" }, this.props.resources.ProductCode),
                    React.createElement("td", null, this.props.pack.productCode)),
                React.createElement("tr", null,
                    React.createElement("th", { scope: "row" }, this.props.resources.SerialNumber),
                    React.createElement("td", null, this.props.pack.serialNumber)),
                React.createElement("tr", null,
                    React.createElement("th", { scope: "row" }, this.props.resources.BatchID),
                    React.createElement("td", null, this.props.pack.batchId)),
                React.createElement("tr", null,
                    React.createElement("th", { scope: "row" }, this.props.resources.ExpiryDate),
                    React.createElement("td", null, this.props.pack.expiryDate)),
                React.createElement("tr", null,
                    React.createElement("th", { scope: "row" }, this.props.resources.PackState),
                    React.createElement("td", null, this.props.pack.packState)),
                React.createElement("tr", null,
                    React.createElement("th", { scope: "row" }, this.props.resources.Status),
                    React.createElement("td", null, this.props.pack.status)),
                React.createElement("tr", null,
                    React.createElement("th", { scope: "row" }, this.props.resources.Message || "Message"),
                    React.createElement("td", null, this.props.pack.information || this.props.pack.warning)),
                this.props.pack.uprc && React.createElement("tr", null,
                    React.createElement("th", { scope: "row" }, this.props.resources.UPRC),
                    React.createElement("td", null, this.props.pack.uprc)))));
    };
    return Details;
}(React.Component));
exports.Details = Details;
//# sourceMappingURL=PackDetailsInformationEvent.js.map